import { css } from "../../utils/styledComponents";
const darkSpaceGray = css `
  :root {
    --ag-border-color: var(--input-border);
    --ag-row-border-color: var(--input-border);
    --ag-background-color: var(--background-color-2);
    --ag-header-background-color: var(--background-color-2);
    --ag-odd-row-background-color: var(--background-color-1);
    --ag-row-hover-color: var(--background-color-0);
  }
  .ag-theme-balham-dark .ag-column-drop-horizontal {
    background-color: var(--background-color-2);
  }

  .ag-theme-balham-dark .ag-column-drop-cell {
    background-color: var(--primary);
  }
`;
export default darkSpaceGray;
